/**
 * O que o navegador lembra da equipe entre uma sessão e outra. Tudo é
 * conveniência: sem localStorage (aba anônima, armazenamento bloqueado) a
 * equipe só perde o atalho.
 */
const CHAVE_ENTRADA = "portal-entrada";
// Contrato, e não mais cliente, desde 09/10/2026: a chave antiga fica esquecida.
const chaveUltimoContrato = (email: string) =>
  `equipe-ultimo-contrato:${email.trim().toLowerCase()}`;

const ler = (chave: string) => {
  try {
    return localStorage.getItem(chave);
  } catch {
    return null;
  }
};

const gravar = (chave: string, valor: string | null) => {
  try {
    if (valor === null) localStorage.removeItem(chave);
    else localStorage.setItem(chave, valor);
  } catch {
    // Sem armazenamento, sem atalho.
  }
};

/**
 * Para onde vai quem perde a sessão: a equipe volta para a própria entrada, e
 * não para o login de usuário e senha, que ela não tem.
 */
export const paginaDeEntrada = () =>
  ler(CHAVE_ENTRADA) === "equipe" ? "/equipe" : "/login";

export const marcarEntrada = (como: "equipe" | "cliente") =>
  gravar(CHAVE_ENTRADA, como === "equipe" ? "equipe" : null);

/** O último contrato atendido por esta pessoa, para entrar direto nele. */
export const ultimoContrato = (email: string): number | null => {
  const valor = Number(ler(chaveUltimoContrato(email)));
  return Number.isInteger(valor) && valor > 0 ? valor : null;
};

export const lembrarContrato = (email: string, idContrato: number | null | undefined) =>
  gravar(chaveUltimoContrato(email), idContrato ? String(idContrato) : null);
